import type { Theme } from '@fluentui/react-components';
import { useMemo } from 'react';

import type { ITheme } from '../../theme.types';
import { createCoreUIFluentThemeFromV8 } from '../createFluent9Theme';

export const useFluent9Theme = (theme: ITheme, fluent9Theme?: Theme): Theme =>
  useMemo(() => {
    if (fluent9Theme) {
      return fluent9Theme;
    }

    return createCoreUIFluentThemeFromV8(theme);
  }, [fluent9Theme, theme]);
